import '../../styles/templates/page.help.pcss';
import '../../styles/components/faq-accordions.pcss';

import {Toggle} from '../ui/toggle';
import {FaqAccordions} from '../ui/faq-accordions';

const accountNavToggle = document.querySelector(
  '[data-help-nav-toggle]'
);

if (accountNavToggle) {
  new Toggle(accountNavToggle);
}

const accordionsWrapper = document.querySelector('[data-faq-accordions]');

if (accordionsWrapper) {
  new FaqAccordions(accordionsWrapper);
}
